module.exports = __webpack_public_path__ + "img/businessScopeImg6.2f2148db.png";